import { cliSimpleGit } from '../cli-simple-git.js';

export async function gitWorktreeAddBranch(
  mainRepoPath: string,
  worktreePath: string,
  branch: string,
  baseRef: string = 'HEAD',
): Promise<void> {
  const mainGit = cliSimpleGit(mainRepoPath);
  const base = baseRef.trim() || 'HEAD';
  await mainGit.raw(['worktree', 'add', '-b', branch, worktreePath, base]);
}
